













































































import {
  ShiftOffDayServiceProxy,
} from "@/service-proxies/app-v2/time.service-proxies";
import {columns} from "./components/column";
import Add from "./components/create.vue";
const service = new ShiftOffDayServiceProxy();
const options = {
  listApi: service.page.bind(service),
  deleteApi: service.remove.bind(service),
};
import moment from 'moment';

export default {
  components: {Add},
  computed: {
    columns() {
      return columns.map((item) => {
        return {
          ...item,
          title: this.$t(item.title),
        };
      }); // 表单配置
    },
    rowSelection() {
      const {selectedRowKeys}: any = this;
      return {
        selectedRowKeys,
        onChange: (selectedRowKeys: any) => {
          this.selectedRowKeys = selectedRowKeys;
        },
      };
    },
  },
  data() {
    return {
      moment,
      dialog: false,
      ...options,
      dataSource: [], // 列表数据
      totalContent: 0, // 总数
      query: {
        size: 30,
        current: 1,
        time: null,
        year: moment()
      },
      form: {},
      selectedRowKeys: [],
      Rowkey: "", // 所选表单行
      open: false,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    handleCreate() {
      this.form = {
        time: null,
        year: moment(),
        startOffDay: null,
        endOffDay: null,
        remark: '',
      };
      this.dialog = true;
    },
    handleSearch() {
      this.query.current = 1;
      this.getList();

    },
    handleDelete() {
      let that = this;
      this.$confirm({
        content: '是否确定删除',
        onOk() {
          that.deleteApi(that.selectedRowKeys).then(res => {
            that.selectedRowKeys = [];
            that.$message.success(that.$t("delete_success"));
            that.getList();
          })
        },
      });
    },
    handleUpdate() {
      this.dialog = false;
      this.getList();
    },
    handleEdit(data) {
      let item = Object.assign({}, data);
      item.time = [moment(new Date(item.startOffDay)), moment(new Date(item.endOffDay))];
      item.year = moment(item.year, 'YYYY');
      this.form = item;
      this.dialog = true;
    },
    async getList() {
      const {year, time} = this.query;
      const res = await this.listApi(
          this.query.current,
          this.query.size,
          {
            endOffDay: this.query.endOffDay,
            startOffDay: this.query.startOffDay,
            year: year.format('YYYY')
          }
      );
      const {data} = res;
      if (data.records.length) {
        this.dataSource = data.records;
        this.totalContent = data.total;
      } else {
        this.dataSource = [];
        this.totalContent = 0;
      }
    },
    pageIndexchange(current: any) {
      this.query.current = current;
      this.getList();
    },
    totalFanyi(number: any) {
      const total = this.$t("Total…items");
      return total.replace("{0}", number);
    },
    disabledDate(showTime) {
      var timeYear = showTime.get('year');  // 当前年
      return timeYear != this.query.year.format('YYYY'); //  不等于选中年度
    },
    openChange(status) {
      if (status) {
        this.open = true;
      } else {
        this.open = false;
      }
    },
    panelChange(value) {
      console.log(value)
      this.query.year = value;
      this.open = false;
    },
    onChange(value, dateString) {
      this.query.startOffDay = dateString[0];
      this.query.endOffDay = dateString[1];
    }
  },
};
